@for (client of clients() | sort: 'name'; track $index) {
  <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
  <button
    mat-menu-item
    class="clientPicker_item"
    [ngStyle]="{
      'cursor': client.id === selectedClientId() ? 'default' : 'pointer'
    }"
    [ngClass]="{ 'selectedClient': client.id === selectedClientId() }"
    [attr.data-cy]="`client-picker-${client.name | dataCySlug}-menu-item`"
    [disabled]="disabled()"
    (click)="client.id !== selectedClientId() && onClientChange(client)">
    <div class="d-flex w-100 align-items-center text-truncate">
      <div class="text-truncate">
        <div class="text-truncate" [title]="client.name">{{ client.name }}</div>

        @if (client.id === selectedClientId()) {
          <div class="text-small text-muted">Active session</div>
        }
      </div>

      @if (client?.logoUrl) {
        <img class="clientPicker_logo ms-auto ps-1" [src]="client?.logoUrl" [alt]="client.name" />
      } @else {
        <span class="ms-auto">&nbsp;</span>
      }
    </div>
  </button>
}
